import {createPersistedState} from '@product-web/shared--web-platform/persisted-state'
import {localStorage} from '@product-web/shared--web-platform/storage/local'

export const [useCreditPersistedState] = createPersistedState('credit', localStorage)
